import { render, staticRenderFns } from "./OpenAppButton.vue?vue&type=template&id=e56bf83c&scoped=true"
import script from "./OpenAppButton.vue?vue&type=script&lang=js"
export * from "./OpenAppButton.vue?vue&type=script&lang=js"
import style0 from "./OpenAppButton.vue?vue&type=style&index=0&id=e56bf83c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56bf83c",
  null
  
)

export default component.exports